import { useEffect, useState } from "react";
import { AdminHeader } from "@trillion/ui/components/admin/admin-header";
import { PageHeader } from "@trillion/ui/components/admin/page-header";
import { StatCard } from "@trillion/ui/components/admin/stat-card";
import { Card } from "@trillion/ui/components/ui/card";
import { Skeleton } from "@trillion/ui/components/ui/skeleton";
import { Brain } from "lucide-react";
import { adminApi } from "@/lib/admin-api";

export function DashboardPage() {
  const [totalIntents, setTotalIntents] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function loadStats() {
      try {
        const stats = await adminApi.intents.stats();
        setTotalIntents(stats.total);
      } catch {
        setTotalIntents(0);
      } finally {
        setIsLoading(false);
      }
    }
    loadStats();
  }, []);

  return (
    <div className="flex flex-col">
      <AdminHeader title="Dashboard" />
      <div className="flex flex-col gap-6 p-6">
        <PageHeader
          title="Dashboard"
          description="Overview of Cortex traffic intent data"
        />
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {isLoading ? (
            <Card className="p-6">
              <Skeleton className="h-4 w-24 mb-2" />
              <Skeleton className="h-8 w-16 mb-1" />
              <Skeleton className="h-3 w-32" />
            </Card>
          ) : (
            <StatCard
              title="Total Intents"
              value={totalIntents ?? 0}
              icon={<Brain className="size-4" />}
              description="Classified traffic intents"
            />
          )}
        </div>
      </div>
    </div>
  );
}
